import {inject, Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {map} from 'rxjs';
import {AppStore} from '../store/app.store';
import {IVendor} from '../../types/IVendor';

@Injectable({
  providedIn: 'root'
})
export class VendorsService extends BaseApiService {
  private appStore = inject(AppStore);

  getVendors() {
    return this.get<Array<{ key: string; name: string }>>(`clients/${this.appStore.client_id()}/vendors`).pipe(
      map(response => response.map(item => ({
        key: item.key,
        name: item.name
      })))
    );
  }

  getVendor(key: string) {
    return this.get<IVendor>(`clients/${this.appStore.client_id()}/vendors/${key}`);
  }
}
